import React from "react";

import QuestionCardEditable from "./QuestionCardEditable";
import QuestionCardViewOnly from "./QuestionCardViewOnly";

const QuestionCard = ({ editable, ...props }) => {
  return editable ? (
    <QuestionCardEditable {...props} />
  ) : (
    <QuestionCardViewOnly {...props} />
  );
};

// export default QuestionCard;

export default React.memo(QuestionCard);
